import type {BridgeUser} from "./BridgeBarData";

const rickRollUrl = "https://www.youtube.com/watch?v=dQw4w9WgXcQ";

export const bridgeApiMockData: BridgeUser = {
  id: "rickroller",
  username: "rickroll2007",
  given_name: "Rick",
  family_name: "Astley",
  solution_links: [
    {
      solutionId: "Admin_DEV",
      label: "Admin",
      uri: rickRollUrl,
      mode: "NEW_WINDOW",
      applications: []
    },
    {
      solutionId: "DDC_DEV",
      label: "Dealer.com",
      uri: rickRollUrl,
      mode: "NEW_WINDOW",
      applications: []
    },
    {
      solutionId: "TESTSOLUTION_ENV1",
      label: "Test Solution (Env1)",
      uri: rickRollUrl,
      applications: [],
      mode: "NEW_WINDOW"
    },
    {
      solutionId: "TESTSOLUTION_ENV2",
      label: "Test Solution (Env2)",
      uri: rickRollUrl,
      applications: [],
      mode: "NEW_WINDOW"
    },
    {
      solutionId: "DTCOM_DEV",
      label: "Dealertrack F&I",
      uri: rickRollUrl,
      mode: "NEW_WINDOW",
      applications: []
    },
    {
      solutionId: "RTS_DEV",
      label: "Reg & Titling",
      uri: rickRollUrl,
      mode: "NEW_WINDOW",
      applications: []
    }
  ],
  display_info: [
    {
      header: "Bridge ID",
      body: "rickroll2007"
    },
    {
      header: "Name",
      body: "RICK ASTLEY"
    }
  ],
  user_links: [
    {
      label: "My Settings",
      uri: rickRollUrl,
      icon: "my-settings",
      menu: "user",
      mode: "NEW_WINDOW"
    },
    {
      label: "Bridge User Admin",
      uri: rickRollUrl,
      icon: "bridge-admin",
      menu: "user",
      mode: "NEW_WINDOW"
    },
    {
      label: "Help",
      uri: rickRollUrl,
      icon: "help",
      menu: "user",
      mode: "NEW_WINDOW"
    },
    {
      label: "Attach More Solutions",
      uri: rickRollUrl,
      icon: "attach-more-solutions",
      menu: "solution",
      mode: "NEW_WINDOW"
    }
  ],
  feature_flags: {}
};
